import React, { useContext, useEffect } from 'react'
import AppContext from '../../context/AppContext';
import { requestData } from '../../services/request';
import "./LoadingPage.css";

function LoadingPage() {

  const { setProductList, setIsLoading, setFiltredList } = useContext(AppContext);

  const data = async () => {
    try {
      const dataJson = await requestData('/clothes');
      await setProductList(dataJson);
      await setFiltredList(dataJson);
      setIsLoading(false);
      return dataJson;
    } catch (error) {
      console.log(error);
    };
  };

  useEffect(() => {
    data();
  }, []);

  return (
    <div>
      <div>
        <img className="logo-loading" src="https://i.postimg.cc/W47Xcyg3/UNI-DUNI-TE-MARCA-DAGUA-Prancheta-1.png" alt="Carregando" />
      </div>
    </div>
  )
};

export default LoadingPage;
